import React from "react";

import UserInfo from "../../../components/UserInfo";
import Page404 from "../extraPages/routes/404";
import ApiGeneral from "../../generalApi";
import { Row, Col } from "antd";
import PaymentCurse from "../../../components/PaymentCurse";

import "./style.css";
const apiGeneral = new ApiGeneral();
// Make sure to call `loadStripe` outside of a component’s render to avoid
const isMobile = window.innerWidth <= 1024;

class Crm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      logged: false,
      content: "",
      title: "",
      route: "",
      is404: false,
      isPublic: false,
    };

    this.userInfoRef = React.createRef();
    this.getUserComponent = this.getUserComponent.bind(this);
  }

  componentDidMount() {
    var _route = this.props.location.pathname.substr(
      this.props.location.pathname.lastIndexOf("/") + 1
    );

    apiGeneral.getPage(_route).then((result) => {
      if (result.val()) {
        var founded = [];

        result.forEach(function (data) {
          let obj = data.val();
          obj._id = data.key;
          founded.push(obj);
        });

        document.title = "Escuelapp | " + founded[0].title;

        this.setState({
          content: founded[0].content,
          title: founded[0].title,
          is404: false,
          route: _route,
          isPublic: founded[0].public,
        });
      } else {
        this.setState({ is404: true });
      }
    });
  }

  getUserComponent() {
    return (
      <UserInfo
        ref={this.userInfoRef}
        visible={true}
        checkUser={(userInfo) => {
          //console.log("LLEGA", userInfo);
          if (userInfo) {
            if (!userInfo.facturacion) {
              userInfo.facturacion = {};
            }
          }

          this.setState({
            logged: userInfo ? userInfo.logged : false,
            userData: userInfo,
          });
        }}
      ></UserInfo>
    );
  }

  getSpecialContent() {
    var _route = this.props.location.pathname.substr(
      this.props.location.pathname.lastIndexOf("/") + 1
    );

    if (_route == "formacion-alto-rendimiento") {
      return <PaymentCurse />;
    }
  }

  render() {
    const contentText = this.state.content || "";
    const is404 = this.state.is404;
    const isPublic = this.state.isPublic;

    console.log("PUBLIC", isPublic, "LOGGED", this.state.logged);

    if (is404) {
      return <Page404 />;
    }

    if (!isPublic && !this.state.logged) {
      return (
        <Row justify="center">
          <Col
            xs={{ span: 24, offset: 0 }}
            sm={{ span: 24, offset: 0 }}
            md={{ span: 24, offset: 0 }}
            lg={{ span: 24, offset: 0 }}
            xl={{ span: 24, offset: 0 }}
            xxl={{ span: 24, offset: 0 }}
            style={{ textAlign: "center" }}
          >
            <h1>Acceso denegado</h1>
            <p>Necesitas estar logueado para acceder a tus facturas</p>
            <p>¿Quieres iniciar sesión?</p>
            <div style={{ textAlign: "center" }}>{this.getUserComponent()}</div>
          </Col>
        </Row>
      );
    }

    return (
      <div
        style={{
          overflow: "auto",
          height: "100vh",
          padding: "20px",

          backgroundColor: "white",
        }}
      >
        <div
          className={isMobile ? "content" : ""}
          dangerouslySetInnerHTML={{ __html: contentText }}
        ></div>
        {this.getSpecialContent()}
      </div>
    );
  }
}

export default Crm;



// WEBPACK FOOTER //
// ./app/routes/crm/index.js